import { Typography } from '@mui/material';
import { useCurrency } from '@procureai/ui-mui';
import Decimal from 'decimal.js';
import { useFormContext } from 'react-hook-form';

import { ContractDemandRequestItem } from '~/modules/contractDemands/ContractDemandRequestWidget/components/ContractDemandRequestLineItems/ContractDemandRequestItemForm.schema.ts';

export const TotalValue = () => {
  const { format } = useCurrency();
  const { watch } = useFormContext<ContractDemandRequestItem>();

  const baselinePricePerPriceUnit = watch('baselinePricePerPriceUnit');
  const quantity = watch('quantity');
  const priceUnit = watch('priceUnit');

  const totalValue =
    baselinePricePerPriceUnit && quantity && priceUnit
      ? new Decimal(quantity).div(priceUnit).mul(baselinePricePerPriceUnit).toNumber()
      : undefined;

  return totalValue ? (
    <Typography variant="h6" color="text.primary">
      {format(totalValue)}
    </Typography>
  ) : null;
};
